import { ChangeDetectionStrategy, Component } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { PaymentModeHintsComponent } from 'mbs-ui-shared@components/licenses/components/payment-mode-hints/payment-mode-hints.component';

@Component({
  selector: 'mbs-payment-methods-modal',
  templateUrl: './payment-methods-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, I18NextPipe, ModalComponent, ModalFooterDirective, PaymentModeHintsComponent]
})
export class PaymentMethodsModalComponent {
  public readonly elementsSelector = {
    name: {
      proceedButton: 'payment-methods-modal_proceed',
      cancelButton: 'payment-methods-modal_cancel'
    }
  };
}
